import React, { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Swal from "sweetalert2";
import RemoveReq from "../../../../../Classes/Models/Requests/SearchStringOrIntReq";
import SessionsApi from "../../../../../Classes/API/Administration/SessionsApi";

import { useNavigate } from "react-router-dom";

const AccSessionTherapistsTable = ({ Session, setIsLoaded }) => {
  let navigate = useNavigate();

  const MakeEntry = (Hour) => {
    navigate("/CreateNewAccountingEntry", {
      state: {
        AccThHour: Hour,
        entryType: "AccountingTherapistHour",
      },
    });
  };
  const TableColumns = [
    { Header: "Type Name", accessor: "TypeName", align: "left" },
    { Header: "Therapist", accessor: "Therapist", align: "center" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const MakeTableRow = (entry) => {
    return {
      TypeName: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {entry.getTherapist.getTherapistType.typeName}
        </MDTypography>
      ),
      Therapist: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {entry.getTherapist.getUser.name}
        </MDTypography>
      ),
    };
  };

  const RefreshTable = (res) => {
    var rows = [];

    if (res.getSessionTherapists) {
      res.getSessionTherapists.forEach((entry) => {
        rows.push(MakeTableRow(entry));
      });
      setTableDataRows(rows);
    }
  };

  useEffect(() => {
    RefreshTable(Session);
  }, []);

  return (
    <>
      <MDBox pt={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </>
  );
};

export default AccSessionTherapistsTable;
